import { render, staticRenderFns } from "./DFis.vue?vue&type=template&id=98bbe582&scoped=true"
import script from "./DFis.vue?vue&type=script&lang=js"
export * from "./DFis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bbe582",
  null
  
)

export default component.exports